// extracted by mini-css-extract-plugin
export default {"secondaryCategoriesStack":"SecondaryCategoriesPage_secondaryCategoriesStack__2vy-T"};